var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfTimer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "auto",
  height: "auto",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 14,
  cy: 14,
  r: 14
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.834 11.1 7.122 9.39a.606.606 0 1 1 .857-.858l1.712 1.712a.606.606 0 1 1-.857.857ZM19.123 11.1a.606.606 0 0 1 0-.857l1.712-1.712a.606.606 0 1 1 .858.858L19.98 11.1a.606.606 0 0 1-.858 0ZM15.014 4.862v3.679a.6.6 0 0 1-.607.606.6.6 0 0 1-.606-.606V4.862a.6.6 0 0 1 .606-.606.6.6 0 0 1 .607.606Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.407 7.934c-4.341 0-7.882 3.541-7.882 7.883 0 4.34 3.54 7.922 7.882 7.922s7.882-3.581 7.882-7.922c0-4.342-3.54-7.883-7.882-7.883Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.407 10.36a5.465 5.465 0 0 0-5.457 5.457c0 3.007 2.45 5.497 5.457 5.497 3.008 0 5.457-2.49 5.457-5.497a5.465 5.465 0 0 0-5.457-5.457Z",
  fill: "#F3F5F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.265 10.246a.606.606 0 0 1 0-.857l1.714-1.715a.606.606 0 1 1 .858.857l-1.715 1.715a.606.606 0 0 1-.857 0Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.55 13.674a.606.606 0 0 0-.857 0l-1.714 1.714a.606.606 0 1 0 .857.857l1.714-1.714a.606.606 0 0 0 0-.857Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.832 3.043h-4.85a.6.6 0 0 0-.606.607v1.212a.6.6 0 0 0 .606.607h4.85a.6.6 0 0 0 .607-.607V3.65a.6.6 0 0 0-.607-.607ZM21.692 10.246l-1.714-1.715a.606.606 0 1 1 .857-.857l1.715 1.715a.606.606 0 1 1-.858.857Z",
  fill: "#F4CC54"
})))));
export default SvgLfTimer;